import { GzRmTopResourcesIncidentsWidgetWebComponent } from './component/GzRmTopResourcesIncidentsWidgetWebComponent';

export { GzRmTopResourcesIncidentsWidgetWebComponent };
